import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { VENDORS } from "./apiRoutes";

const mutateAddVendorFinancialInfo = async ({
  vendorId,
  data,
}: {
  vendorId: string;
  data: FieldValues;
}) => {
  return await axiosAuth.post(`${VENDORS}/${vendorId}/financial-details`, data);
};

const useAddVendorFinancialInfoMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      vendorId: string;
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddVendorFinancialInfo,
    ...queryParams,
  });

export default useAddVendorFinancialInfoMutation;
